import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Portal Integrador';

  constructor(
    private router: Router) { }

  // exibeMenuLogin(): boolean {
  //   return this.router.url.indexOf('/dashboard') != -1;
  // }

  // exibeMenuLogin2(): boolean {
  //   return this.router.url.indexOf('/registro') != -1;
  // }

  exibeMenus(): boolean {
    return this.router.url !== '/login';
  }  
}
